<template>
  <section :style="isMobile ? '' : 'width: 75%; margin: auto'">
    <h1>{{ $route.name === 'AdminComprarSenhaPage' ? 'Admin - Comprar Senha' : 'Comprar Senha' }}</h1>

    <v-stepper-vertical v-model="step">
      <template #default>
        <v-stepper-vertical-item
          :complete="step > 1"
          subtitle="Preencha os dados da Senha"
          title="Senha da Vaquejada"
          value="1"
        >
          <v-form ref="formStepOne" v-model="forms.validStepOne">
            <v-select
              v-model="categoria"
              density="compact"
              :item-props="categoriasProps"
              :items="vaquejada?.categorias ?? []"
              label="Categoria do Vaqueiro"
              variant="outlined"
              :rules="[(v) => !!v || 'Categoria é obrigatória']"
              return-object
            />

            <v-btn
              v-if="!senhaSelecionada"
              v-show="categoria"
              text="Selecione Sua Senha"
              @click="abrirDialogSenha"
              variant="elevated"
              style="margin-bottom: 20px"
              color="primary"
            />
            <v-chip
              v-else
              color="primary"
              :value="senhaSelecionada"
              style="margin-bottom: 20px"
            >
              Senha {{ String(senhaSelecionada).padStart(3, '0') }}
              <v-icon
                style="margin-left: 5px"
                icon="mdi-close-circle"
                @click="mostrarMapaSenhas = true; senhaSelecionada = null"
                variant="text"
                color="red"
              />
            </v-chip>
            <GeradorMapaSenhas
              v-if="vaquejada && mostrarMapaSenhas"
              :active="dialogSenha"
              :quantidade-senhas="vaquejada?.quantidadeSenhas ?? 0"
              :data-inicio="vaquejada?.dataInicio ?? ''"
              :data-fim="vaquejada?.dataFim ?? ''"
              :senhas="vaquejada?.vendas ?? []"
              :dias-senhas="vaquejada?.diasSenhas ?? []"
              :is-admin="$props.isAdmin"
              @senha-selecionada="getSenhaSelecionadaEvent"
              @update:active="dialogSenha = $event"
            />

            <v-checkbox density="compact" color="primary" v-model="incluiBoi" v-if="vaquejada?.valorBoi > 0">
              <template #label>
                <div style="display: flex; flex-direction: column">
                  <span>Incluir Boi de TV?</span>
                  <span style="font-size: 10px">{{ Number(vaquejada?.valorBoi).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</span>
                </div>
              </template>
            </v-checkbox>

            <v-text-field
              v-model="representacao"
              density="compact"
              label="Representação"
              variant="outlined"
              :rules="[(v) => !!v || 'Representação é obrigatória']"
            />
          </v-form>
          <template #next="{ next }: any">
            <v-btn color="primary" text="Continuar" @click="proximoPasso(next)" :disabled="!forms.validStepOne || !senhaSelecionada" />
          </template>

          <template #prev />
        </v-stepper-vertical-item>

        <v-stepper-vertical-item
          :complete="step > 2"
          subtitle="Selecione o Vaqueiro ou Cadastre um novo"
          title="Dados do Vaqueiro"
          value="2"
        >
          <p v-if="vaqueiro && esteira">Vaqueiro</p>
          <SelecionarVaqueiro v-if="!vaqueiro" @selecionar-vaqueiro="selecionarVaqueiro" label-input="Buscar Vaqueiro por Nome" />

          <v-list density="compact" v-if="vaqueiro" variant="outlined" style="margin-bottom: 15px">
            <v-list-item
              :title="vaqueiro.nome"
              :subtitle="vaqueiro.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')"
              base-color="primary"
              rounded
            >
              <template #append>
                <v-btn icon="mdi-close-circle" color="red" variant="text" @click="selecionarVaqueiro(null)" />
              </template>
            </v-list-item>
          </v-list>

          <p v-if="vaqueiro && !clickSelecionarEsteira" style="margin-bottom: 10px; font-size: 12px; text-align: center">
            Vaqueiro selecionado! Deseja selecionar o Esteira? Clique no botão abaixo.
          </p>

          <div v-if="vaqueiro && !clickSelecionarEsteira" style="width: fit-content; margin: auto">
            <v-btn
              color="success"
              prepend-icon="mdi-account-plus"
              text="Selecionar Esteira"
              @click="clickSelecionarEsteira = true"
              style="margin-bottom: 20px"
              size="small"
            />
          </div>

          <p v-if="vaqueiro && esteira">Esteira</p>
          <SelecionarVaqueiro
            :zerar-vaqueiro="zerarVaqueiro"
            label-input="Buscar Esteira por Nome"
            action-text-button="Cadastrar Esteira"
            @selecionar-vaqueiro="selecionarEsteira"
            @update:zerar-vaqueiro="zerarVaqueiro = $event"
            v-if="clickSelecionarEsteira && vaqueiro && !esteira"
          />

          <v-list density="compact" v-if="esteira" variant="outlined" style="margin-bottom: 15px">
            <v-list-item
              :title="esteira.nome"
              :subtitle="esteira.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4')"
              base-color="primary"
              rounded
            >
              <template #append>
                <v-btn icon="mdi-close-circle" color="red" variant="text" @click="selecionarEsteira(null)" />
              </template>
            </v-list-item>
          </v-list>

          <p v-if="zerarVaqueiroMsg" style="font-size: 12px; color: red; margin-top: 15px">
            Esteira não pode ser o mesmo que o Vaqueiro.
          </p>

          <template #next="{ next }: any">
            <v-btn color="primary" text="Continuar" @click="proximoPasso(next)" :disabled="!vaqueiro" />
          </template>

          <template #prev="{ prev }: any">
            <v-btn text="Voltar" @click="prev" />
          </template>
        </v-stepper-vertical-item>

        <v-stepper-vertical-item
          :complete="step > 3"
          subtitle="Selecione a forma de pagamento"
          title="Pagamento"
          value="3"
        >
          <v-select
            v-model="formaPagamento"
            density="compact"
            :items="getFormasPagamento"
            item-title="title"
            item-value="value"
            label="Forma de Pagamento"
            variant="outlined"
            style="margin-bottom: 10px"
          />

          <p style="margin-bottom: 10px; font-size: 13px; color: #1867C0" v-if="pagamentos.find((p) => p.value === formaPagamento)?.title === 'Cortesia'">
            Você selecionou a opção de cortesia. Continue sua compra, o administrador irá validar com a organização.
          </p>

          <v-text-field
            v-if="isAdmin && pagamentos.find((p) => p.value === formaPagamento)?.title !== 'Cortesia'"
            v-model="desconto"
            density="compact"
            label="Desconto"
            prefix="R$"
            step="0.01"
            variant="outlined"
            style="margin-bottom: 10px"
            type="number"
            :rules="[(v) => v <= (Number(categoria?.valor) + (incluiBoi ? Number(vaquejada.valorBoi) : 0)) || 'Desconto não pode ser maior que o valor total']"
          />

          <p style="margin-bottom: 10px; font-size: 13px; color: #1867C0" v-if="pagamentos.find((p) => p.value === formaPagamento)?.title === 'Cartão de Crédito' || pagamentos.find((p) => p.value === formaPagamento)?.title === 'Cartão de Débito'">
            Pagamentos no cartão de crédito/débito sofrerão acréscimo devido a taxa da maquineta.
          </p>

          <p v-if="$route.name === 'AdminComprarSenhaPage'" style="color: red; font-size: 13px">
            Você está cadastrando uma senha como Administrador. Por padrão, todas as senhas cadastradas
            por Administradores serão automaticamente validadas.
          </p>

          <template #next="{ next }: any">
            <v-btn color="primary" text="Continuar" @click="proximoPasso(next)" :disabled="!formaPagamento" />
          </template>

          <template #prev="{ prev }: any">
            <v-btn text="Voltar" @click="prev" />
          </template>
        </v-stepper-vertical-item>

        <v-stepper-vertical-item
          :complete="step > 4"
          subtitle="Verifique o resumo da compra"
          title="Resumo"
          value="4"
        >
          <v-list density="compact">
            <v-list-item>
              <v-list-item-title style="font-weight: bold">Cliente</v-list-item-title>
              <v-list-item-subtitle style="opacity: 1">
                <v-divider opacity="1" />
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>{{ store.getCarrinhoUserData.nome }}</v-list-item-title>
              <v-list-item-subtitle>{{ store.getCarrinhoUserData.cpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '***.$2.$3-**') }}</v-list-item-subtitle>
            </v-list-item>

            <v-list-item>
              <v-list-item-title style="font-weight: bold">Vaquejada</v-list-item-title>
              <v-list-item-subtitle style="opacity: 1">
                <v-divider opacity="1" />
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>{{ vaquejada?.nome }}</v-list-item-title>
              <v-list-item-subtitle style="text-wrap: nowrap">{{ vaquejada?.city.nome }} - {{ vaquejada?.city.estado }}</v-list-item-subtitle>
              <v-list-item-subtitle>{{ vaquejada?.dataInicio.split('T')[0].split('-').reverse().join('/') }}</v-list-item-subtitle>
            </v-list-item>

            <v-list-item>
              <v-list-item-title style="font-weight: bold">{{ store.getCarrinho.vendas.length === 1 ? 'Senha' : 'Senhas' }}</v-list-item-title>
              <v-list-item-subtitle style="opacity: 1">
                <v-divider opacity="1" />
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <div style="display: flex; flex-direction: row; flex-wrap: wrap">
                <div
                  v-for="(ven, index) in store.getCarrinho.vendas"
                  :key="index"
                  :style="store.getIsDark ? 'border-color: #424242; background-color: #424242' : 'border-color: #E0E0E0; background-color: #F5F5F5'"
                  style="padding: 10px; display: flex; flex-direction: column; border-radius: 12px; margin: 0 3px 5px; position: relative"
                >
                  <v-btn
                    icon="mdi-close"
                    color="red"
                    style="position: absolute; right: 0; top: 0"
                    variant="text"
                    size="x-small"
                    @click="store.removeVenda(index)"
                  />
                  <span style="text-align: center; font-weight: bold">Senha {{ String(ven.numeroSenha).padStart(3, '0') }}</span>
                  <span>Categoria: {{ (vaquejada.categorias.find((c) => c.categoria.id === ven.categoria)).categoria.nome }}</span>
                  <span v-if="ven.representante && ven.representante !== ''">Representação: {{ ven.representante }}</span>
                  <span v-if="ven.esteira && ven.esteira > 0">Esteira: {{ getUserFromStore(ven.esteira).nome }}</span>
                  <span>Valor da senha: {{ (vaquejada.categorias.find((c) => c.categoria.id === ven.categoria)).valor.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' }) }}</span>
                  <span v-if="vaquejada.valorBoi > 0">Boi de TV: {{ ven.boiTv ? `Sim (${vaquejada.valorBoi.toLocaleString('pt-br', { style: 'currency', currency: 'BRL' })})` : 'Não' }}</span>
                </div>
                <div class="add-senha-hover" style="display: grid; place-items: center; padding: 10px; border: 2px dashed; border-radius: 12px; margin: 0 5px 5px; width: 200px; cursor: pointer; transition: all 300ms" @click="continuar">
                  <v-icon class="add-senha-icon" size="80px">mdi-plus-circle-outline</v-icon>
                </div>
              </div>
            </v-list-item>

            <v-list-item>
              <v-list-item-title style="font-weight: bold">Forma de Pagamento</v-list-item-title>
              <v-list-item-subtitle style="opacity: 1">
                <v-divider opacity="1" />
              </v-list-item-subtitle>
            </v-list-item>
            <v-list-item>
              <v-list-item-title>{{ pagamentos.find((p) => p.value === formaPagamento)?.title }}</v-list-item-title>
              <v-list-item-subtitle style="color: red; opacity: 1" v-if="isEligibleToDiscount">Desconto Promocional: - {{ Number(getDiscount).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</v-list-item-subtitle>
              <v-list-item-subtitle style="color: red; opacity: 1" v-if="desconto && desconto > 0">Desconto: - {{ Number(desconto).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</v-list-item-subtitle>
              <v-list-item-subtitle style="font-weight: bold; opacity: 1">Total: {{ Number((getTotalCompra - (isEligibleToDiscount ? getDiscount : 0)) - desconto).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) }}</v-list-item-subtitle>
            </v-list-item>
          </v-list>

          <template #next>
            <v-btn color="success" variant="elevated" :loading="loading" text="Finalizar" @click="finalizarCompra" />
          </template>

          <template #prev="{ prev }: any">
            <v-btn text="Voltar" @click="prev" :disabled="loading" />
          </template>
        </v-stepper-vertical-item>
      </template>
    </v-stepper-vertical>

    <v-snackbar v-model="snackbar.active" :color="snackbar.color" location="top" :timeout="snackbar.timeout">
      <template #default> {{ snackbar.text }} </template>
      <template #actions>
        <v-btn color="white" text="Fechar" @click="snackbar.active = false" />
      </template>
    </v-snackbar>

    <v-btn
      v-if="store.getSenhasNoCarrinho.length > 0"
      color="primary"
      icon
      size="large"
      style="position: fixed; bottom: 20px; right: 20px; z-index: 1; border: 1px solid white"
      @click="abrirCarrinho"
    >
      <v-badge location="top right" color="red" :content="store.getSenhasNoCarrinho.length">
        <v-icon icon="mdi-cart" />
      </v-badge>
      <v-tooltip
        activator="parent"
        location="start"
      >{{ `${store.getSenhasNoCarrinho.length} senha${store.getSenhasNoCarrinho.length > 1 ? 's' : ''}` }} no carrinho</v-tooltip>
    </v-btn>
  </section>

  <v-dialog persistent v-model="dialogAviso" width="auto" v-if="!isAdmin" @keydown.enter="dialogAviso = false">
    <v-card title="Atenção" :max-width="isMobile ? '100%' : '500px'">
      <template #prepend>
        <v-icon icon="mdi-alert" color="primary" />
      </template>
      <v-card-text>
        De acordo com as regras do evento, cada vaqueiro só pode adquirir senhas dentro da sua categoria. Caso compre uma senha fora da sua categoria, a organização fará a correção automática.
        <br>
        <br>
        Por favor, revise sua escolha antes de continuar.
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn variant="elevated" color="primary" text="OK" @click="dialogAviso = false" />
      </v-card-actions>
    </v-card>
  </v-dialog>

  <v-dialog persistent v-model="dialogCarrinhoCheck" width="auto">
    <v-card title="Adicionado ao Carrinho de Compras" :max-width="isMobile ? '100%' : '500px'">
      <template #prepend>
        <v-icon icon="mdi-check" color="success" />
      </template>
      <v-card-text>
        Deseja adicionar mais uma senha ao carrinho de compras? Clique no botão "Continuar".
        <br>
        <br>
        Para finalizar sua compra, clique no botão "Finalizar".
      </v-card-text>
      <v-card-actions>
        <v-btn variant="elevated" color="primary" text="Continuar" @click="continuar" />
        <v-spacer />
        <v-btn variant="elevated" color="success" text="Finalizar" @click="finalizarCarrinho" />
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script lang="ts">
  import GeradorMapaSenhas from '@/components/ComprarSenhaPage/GeradorMapaSenhas.vue'
  import SelecionarVaqueiro from '@/components/ComprarSenhaPage/SelecionarVaqueiro.vue'
  import { VStepperVertical, VStepperVerticalItem } from 'vuetify/labs/VStepperVertical'
  import { CadastrarCompraDto, Venda } from '@/types/global'
  import { useAppStore } from '@/stores/app'
  export default {
    name: 'ComprarSenhaPage',
    components: {
      SelecionarVaqueiro,
      GeradorMapaSenhas,
      VStepperVertical,
      VStepperVerticalItem,
    },
    props: {
      isAdmin: {
        type: Boolean,
        required: true
      }
    },
    data: () => ({
      vaquejada: null,
      store: useAppStore(),
      payload: {
        vendas: [] as Venda[],
        user: null,
        userData: {
          nome: '',
          cpf: '',
        },
        vaquejada: null,
        isAdmin: false,
        desconto: null,
        formaPagamento: null,
      } as CadastrarCompraDto,
      dialogCarrinhoCheck: false,
      mostrarMapaSenhas: false,
      senhaSelecionada: null,
      diaSelecionado: null,
      dialogSenha: false,
      categoria: null,
      incluiBoi: false,
      representacao: null,
      step: 1,
      forms: {
        validStepOne: false
      },
      vaqueiro: null,
      esteira: null,
      clickSelecionarEsteira: false,
      zerarVaqueiro: false,
      zerarVaqueiroMsg: false,
      formaPagamento: null,
      desconto: null,
      loading: false,
      snackbar: {
        active: false,
        text: '',
        color: '',
        timeout: 6000
      },
      pagamentos: [
        {
          title: 'Dinheiro',
          value: 1
        },
        {
          title: 'Cartão de Crédito',
          value: 2
        },
        {
          title: 'Cartão de Débito',
          value: 4
        },
        {
          title: 'PIX',
          value: 5
        },
        {
          title: 'Cortesia',
          value: 7
        }
      ],
      dialogAviso: true,
    }),
    methods: {
      getUserFromStore(id: number) {
        return this.store.getUserById(id);
      },
      async finalizarCompra () {
        try {
          this.loading = true;
          const response = await this.axios.post(`vendas`, this.store.getCarrinho as FormData, { headers: { 'Content-Type': 'application/json' } });
          if (response.status === 201) {
            this.snackbar.active = true;
            if (this.formaPagamento === 7) {
              this.snackbar.text = 'Sua senha está reservada. Você selecionou a opção cortesia. A administração irá validar com a organização.';
            } else {
              this.snackbar.text = 'Sua senha está reservada, mas só passará a valer após o pagamento ser confirmado.';
            }
            this.abrirWhatsapp();
            this.snackbar.timeout = 10000;
            this.snackbar.color = 'success';

            this.$nextTick(() => {
              this.store.clearCarrinho();
              this.reset();
              this.list();
            });
          }
        } catch (error) {
          console.log(error)
          this.snackbar.active = true;
          this.snackbar.text = 'Erro ao comprar senha! ' + error.response.data.error.split('\n').pop();
          this.snackbar.color = 'error';
        } finally {
          this.loading = false;
        }
      },
      async list () {
        try {
          const response = await this.axios.get(`vaquejadas/${this.$route.params.id}?includeCity=true`);
          this.vaquejada = response.data.vaquejada;
        } catch (error) {
          console.log(error.response.data.error);
        }
      },
      categoriasProps (item) {
        return {
          subtitle: `${Number(item.valor).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}${item.limiteSenhas > 0 ? ` - Limite de ${item.limiteSenhas}` : ''}`,
          title: item.categoria.nome,
          value: item
        }
      },
      async proximoPasso (nextFunction) {
        if (this.step === 1) {
          await this.$refs.formStepOne.validate();
          if (!this.forms.validStepOne || !this.senhaSelecionada) return;
          if (!this.senhaSelecionada) return this.dialogSenha = true;
        }
        if (this.step === 2) {
          this.beforeComplete();
          this.dialogCarrinhoCheck = true;
          return;
        }
        if (this.step === 3) {
          this.afterComplete();
        }
        nextFunction();
      },
      selecionarVaqueiro (vaqueiro) {
        if (vaqueiro) {
          this.vaqueiro = { ...vaqueiro };
        } else {
          this.vaqueiro = null;
        }
      },
      selecionarEsteira (esteira) {
        if (esteira) {
          if (this.vaqueiro.id === esteira.id) {
            this.zerarVaqueiro = true;
            this.zerarVaqueiroMsg = true;
            return;
          }
          this.esteira = { ...esteira };
        } else {
          this.esteira = null;
        }
        this.zerarVaqueiro = false;
        this.zerarVaqueiroMsg = false;
      },
      reset () {
        this.esteira = null;
        this.vaqueiro = null;
        this.senhaSelecionada = null;
        this.incluiBoi = false;
        this.formaPagamento = null;
        this.step = 1;
        this.categoria = null;
        this.representacao = null;
        this.mostrarMapaSenhas = false;
      },
      getSenhaSelecionadaEvent (eventData) {
        this.senhaSelecionada = eventData.senha;
        this.diaSelecionado = eventData.dia;
        this.mostrarMapaSenhas = false;
        this.dialogSenha = false;
      },
      abrirDialogSenha () {
        this.mostrarMapaSenhas = true;
        this.$nextTick(() => {
          this.dialogSenha = true;
        });
      },
      abrirWhatsapp() {
        const whatsappNumber = '55' + this.vaquejada.destinatarioPix.contato.replace(/\D/g, '');
        const message = `*AF Secretaria*
_Gestão simplificada para vaquejada._

Olá, gostaria de efetuar o pagamento da minha senha.

*Dados da Vaquejada*
• *Vaquejada:* ${this.vaquejada.nome}
• *Data:* ${this.vaquejada.dataInicio.split('T')[0].split('-').reverse().join('/')}

*Dados do Cliente*
• *Nome:* ${this.store.getUserById(this.store.getCarrinho.user).nome}
• *CPF: ${this.store.getUserById(this.store.getCarrinho.user).cpf}*

*Dados das Senhas*
${this.store.getCarrinho.vendas.map((v) => {
  return `• *Senha:* ${String(v.numeroSenha).padStart(3, '0')}
      - *Representação:* ${v.representante}${v.esteira ? '\n      - *Esteira:* ' + this.getUserFromStore(v.esteira).nome : ''}
      - *Categoria:* ${(this.vaquejada.categorias.find((c) => c.categoria.id === v.categoria)).categoria.nome}
      - *Valor:* ${(this.vaquejada.categorias.find((c) => c.categoria.id === v.categoria)).valor.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
      - *Boi de TV:* ${v.boiTv ? 'Sim (' + this.vaquejada.valorBoi.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }) + ')' : 'Não'}`;
        }).join('\n')}

*Dados de Pagamento*
• *Forma:* ${this.pagamentos.find((p) => p.value === this.formaPagamento)?.title}
${this.isEligibleToDiscount ? `• *Desconto:* ${this.getDiscount.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}` : ''}
• *Valor Total:* ${((this.getTotalCompra - (this.isEligibleToDiscount ? this.getDiscount : 0)) - (this.desconto ? this.disconto : 0)).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' })}
${this.formaPagamento === 5
          ? `• *Chave Pix*
    ${this.vaquejada.destinatarioPix.chavePix}
    ${this.vaquejada.destinatarioPix.nome}`
        : ''}

Em caso de dúvidas, estamos à disposição.
Equipe *AF Secretaria*
`;

        const url = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(message)}`;
        window.open(url, '_blank', 'noopener,noreferrer');
      },
      continuar() {
        this.step = 1;
        this.dialogCarrinhoCheck = false;
        this.senhaSelecionada = null;
        this.diaSelecionado = null;

        window.scrollTo({ top: 0, behavior: 'smooth' });
      },
      finalizarCarrinho () {
        this.step = 3;
        this.dialogCarrinhoCheck = false;
      },
      beforeComplete () {
        if (this.store.getCarrinho.vendas.length === 0) {
          this.store.setCarrinhoUser(this.vaqueiro.id);
          this.store.setCarrinhoUserData({
            nome: this.vaqueiro.nome,
            cpf: this.vaqueiro.cpf,
          });
          this.store.setCarrinhoVaquejada(this.vaquejada.id);
          this.store.setCarrinhoAdmin(this.isAdmin);
        }
        this.store.addVenda({
          esteira: this.esteira?.id || 0,
          boiTv: this.incluiBoi,
          categoria: this.categoria.categoria.id,
          representante: this.representacao,
          user: this.vaqueiro.id,
          numeroSenha: this.senhaSelecionada,
          idDia: this.diaSelecionado,
        });
      },
      afterComplete () {
        this.store.setCarrinhoFormaPagamento(this.formaPagamento);
        this.store.setCarrinhoDesconto(this.desconto);
      },
      abrirCarrinho () {
        //
      }
    },
    async created () {
      await this.list();

      // for (let n = 0; n < 40; n++) {
      //   const formData = new FormData();
      //   formData.append('boiTv', true);
      //   formData.append('formaPagamento', 4);
      //   formData.append('idCategoria', 2);
      //   formData.append('idVaquejada', 9);
      //   formData.append('representante', 'teste');
      //   formData.append('idUser', 2);
      //   formData.append('numeroSenha', (n + 1));
      //   formData.append('idDia', 1);
      //
      //   await this.axios.post('vendas', formData, { headers: { 'Content-Type': 'application/json' } });
      // }
    },
    computed: {
      isMobile() {
        return this.$vuetify.display.mobile;
      },
      getFormasPagamento() {
        // se não for admin, filtra e retira a opção de cortesia
        if (!this.isAdmin) {
          return this.pagamentos.filter(p => p.value !== 7);
        }
        return this.pagamentos;
      },
      getTotalCompra() {
        const vendas = this.store.getCarrinho.vendas;
        let total = 0;
        vendas.forEach(v => {
          const categoria = this.vaquejada.categorias.find(c => c.categoria.id === v.categoria);
          if (categoria) {
            total += categoria.valor;
            if (v.boiTv) {
              total += this.vaquejada.valorBoi;
            }
          }
        });
        return total;
      },
      isEligibleToDiscount(): boolean {
        if (this.vaquejada.categoriaDescontoVaquejada.length > 0) {
          for (const cat of this.vaquejada.categoriaDescontoVaquejada) {
            const quantidade = this.store.getCarrinho.vendas.filter(v => v.categoria === cat.categoria.id).length;
            if (quantidade >= cat.quantidadeSenhas) {
              return true;
            }
          }
          return false;
        } else if (this.vaquejada.numeroSenhasDesconto > 0) {
          if (this.store.getCarrinho.vendas.length >= this.vaquejada.numeroSenhasDesconto) {
            return true;
          }
          return false;
        } else {
          return false;
        }
      },
      getDiscount() {
        if (this.isEligibleToDiscount) {
          const discountType = this.vaquejada.tipoDesconto; // 1 = valor fixo, 2 = percentual
          const discountOnCategory = this.vaquejada.categoriaDescontoVaquejada.length > 0;

          if (discountOnCategory) {
            let totalDiscount = 0;
            for (const cat of this.vaquejada.categoriaDescontoVaquejada) {
              for (const venda of this.store.getCarrinho.vendas) {
                if (venda.categoria === cat.categoria.id) {
                  const quantidade = this.store.getCarrinho.vendas.filter(v => v.categoria === cat.categoria.id).length;
                  if (quantidade >= cat.quantidadeSenhas) {
                    if (discountType === 1) {
                      totalDiscount = cat.valorDesconto;
                    } else if (discountType === 2) {
                      const categoria = this.vaquejada.categorias.find(c => c.categoria.id === cat.categoria.id);
                      if (categoria) {
                        totalDiscount = ((categoria.valor + (venda.boiTv ? this.vaquejada.valorBoi : 0)) * cat.valorDesconto) / 100;
                      }
                    }
                  }
                }
              }
            }
            return totalDiscount;
          } else {
            const total = this.getTotalCompra;
            if (discountType === 1) {
              return this.vaquejada.valorDesconto;
            } else if (discountType === 2) {
              return (total * this.vaquejada.valorDesconto) / 100;
            }
            return 0;
          }
        }
        return 0;
      }
    },
    watch: {
      categoria(newValue, oldValue) {
        // se o antigo valor era null, quer dizer que é a primeira vez que está selecionando a categoria
        if (oldValue === null && newValue) {
          this.abrirDialogSenha();
        }
      }
    }
  }
</script>

<style scoped>
.subtitulo {
  color: #1867C0;
  font-size: 11px;
}
.titulo {
  font-size: 15px;
}

.add-senha-hover:hover {
  background-color: #3f84d2;
}

.add-senha-hover:hover .add-senha-icon {
  color: white;
}
</style>
